module.exports = __webpack_public_path__ + "static/media/screen5.42202ca7.png";